<template>
  <div id="dashboard">
    <v-container class="mt-5" fluid>
      <v-row>
        <v-col
          v-for="item in availableItems" :key="item.text"
          cols="12"
          sm="6"
          md="3"
        >
          <DashboardButton
            :text="item.text"
            :icon="item.icon"
            :pathName="item.path"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import DashboardButton from '@/components/commons/DashboardButton'
import { hasPermission } from '@/utils'
import { mapState } from 'vuex'

export default {
  components: { DashboardButton },
  data() {
    return {
      items: [
        {
          text: 'Usuarios',
          path: 'Users',
          icon: 'mdi-account-group',
          permission: 'menu-users'
        },
        {
          text: 'Estado de Cuenta',
          path: 'AccountStatement',
          icon: 'mdi-file-chart-outline',
          permission: 'menu-account-statement'
        },
        {
          text: 'Brokers',
          path: 'Brokers',
          icon: 'mdi-handshake-outline',
          permission: 'menu-brokers'
        },
        {
          text: 'Roles y Permisos',
          path: 'GroupsCustomer',
          icon: 'mdi-shield-account-outline',
          permission: 'menu-roles'
        },
        {
          text: 'Idiomas',
          path: 'Languages',
          icon: 'mdi-translate',
          permission: 'menu-multi-languages'
        },
        {
          text: 'Preguntas de Seguridad',
          path: 'Questions',
          icon: 'mdi-security',
          permission: 'menu-questions'
        },
        {
          text: 'Log de Actividades',
          path: 'ActivityLog',
          icon: 'mdi-clipboard-account-outline',
          permission: 'menu-activities-log'
        },
        {
          text: 'Parámetros',
          path: 'adminParameters',
          icon: 'mdi-cogs',
          permission: 'menu-settings'
        },
      ]
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    availableItems() {
      return this.items.filter(item => this.hasPermission(item.permission))
    }
  },
  methods: {
    hasPermission(permission) {
      return hasPermission(this.user, permission)
    }
  }
}
</script>
<style scoped>
.card-menu {
  background: url('../assets/av-background.webp') no-repeat center center;
  background-size: cover;
}
</style>
